import React, { Component } from 'react';
import Chip from 'material-ui/Chip';
import DCButtons from './DCButtons'
import EditButton from './EditButton';
import jQuery from 'jquery';
import {
	Create,
	SimpleForm,
	Datagrid,
	Edit,
	List,
	Responsive,
	SimpleList,
	TextField,
	TextInput,
	ReferenceInput,
	SelectInput,
	FormTab,
	NumberInput,
	DateInput,
	TabbedForm,
	FunctionField
} from 'admin-on-rest';
import {
	ReferenceField,
} from 'admin-on-rest/lib/mui';
import { formatDate, stringHumanize, dateString } from '../util'
import AccountListActions from '../AccountListActions'
import customerName from '../CollectorAccount/customerName'
import EditActions from './EditActions'
import DocDefEditTab from './DocDefEditTab'
import PendingDocsEditTab from './PendingDocsEditTab'
import AccountFilters from './AccountFilters'
import DocStatus from './DocStatus'
import { restURL } from '../App'
import HttpError from '../rest/HttpError'
import AccountLinkField from './AccountLinkField'

import { connect } from 'react-redux'
import { change, Field, formValueSelector } from 'redux-form'

const inlineStyle = {
	display: 'inline-block',
	marginRight: 32,
	verticalAlign: 'top',
}

const simpleStatus = ({ id, fields }) => <Chip>{stringHumanize(fields.status)}</Chip>

// Removes commas from a float.
const cleanNumber = value => parseFloat( String( value ).replace( /,/g, '' ) ).toFixed( 2 )

// Adds commas to a number.
const formatNumber = value => {
	const newValue = parseFloat( String( value ).replace( /,/g, '' ) ).toFixed( 2 ).replace( /\d(?=(\d{3})+\.)/g, '$&,' )
	return newValue === 'NaN' ? '' : newValue
}

const removeMultipleSpaces = value => value.replace( /\s+/g, ' ' ).trim()

const removeSpaces = value => value.replace( / /g, '' )

const cleanCSNum = value => value.replace( /[^a-zA-Z0-9]/gi, '' )

const isNotBlank = value => typeof value !== 'undefined' && value !== '' && value !== null
	

/*
const accountStatus = ({id, fields}) => {
	if ( fields.has_doc_def ) {
		return (
			<Chip backgroundColor="#e91e63" labelColor="#fff" containerElement={<Link to={{
					pathname: `/accounts/${id}`,
					search: stringify({ tab: 3 }),
				}} />} >
				<Avatar backgroundColor="#c2185b" color="#fff" icon={<AlertWarning />} />
				Doc Def
			</Chip>
		)
	}
	if ( fields.has_pending_docs ) {
		return (
			<Chip backgroundColor="#ffc107" labelColor="#fff" containerElement={<Link to={{
		            pathname: `/accounts/${id}`,
		            search: stringify({ tab: 2 }),
		        }} />} >
				<Avatar backgroundColor="#ffa000" color="#fff" icon={<AlertWarning />} />
				Pending Docs
			</Chip>
		)
	}
	if ( fields.is_released && ! fields.is_transmitted ) {
		return (
			<Chip>
				Released
			</Chip>
		)
	}
	// if ( ! fields.is_released && fields.is_transmitted ) {
	// 	return (
	// 		<Chip>
	// 			Transmitted
	// 		</Chip>
	// 	)
	// }
	if ( 'new' !== fields.status ) {
		return <Chip>{stringHumanize(fields.status)}</Chip>
	}
	return null;
}
*/

const AccountTitle = ({ record }) => (
	<span>
		Account
		<span style={{ color: '#999' }}>&nbsp; &middot; &nbsp;</span>
		ID {record.id}
		<span style={{ color: '#999' }}>&nbsp; &middot; &nbsp;</span>
		CS# {record.fields.cs_num}
	</span>
)

export class _DCAccountEdit extends Component {
	state = {
		focusedCurrency: false,
	}

	getURLParam(name) {
	    return (this.props.location.search.split(name + '=')[1] || '').split('&')[0];
	}

	componentWillRender() {
		this.movedTabs = false;
	}

    // componentWillReceiveProps( nextProps ) {
	// 	// These are the input fields that display currencies.
	// 	const currencyValues = {
	// 		'fields.proceeds': 'proceedsValue',
	// 		'fields.invoice_amount': 'invoiceAmount',
	// 		'fields.di_amount': 'diAmount',
	// 		'fields.chattel_mortgage_fee': 'chattelMortgageFeeAmount',
	// 	}
	// 	Object.keys( currencyValues ).forEach( field => {
	// 		const propName = currencyValues[ field ]

	// 		// Change the format
	// 		console.log(this.props[ propName ], nextProps[ propName ])
	// 		if ( typeof this.props[ propName ] === 'undefined' ) {
	// 		// console.log(this.props[propName], nextProps[ propName ])
	// 		// if ( String( nextProps[ propName ] ).match( /^\d{4,}/ ) && ! String( nextProps[ propName ] ).match( /,/g ) ) {
	// 			setTimeout( () => this.props.changeCurrency( formatNumber( nextProps[ propName ] ), field ), 1 )
	// 		}
	// 	} )
    // }

	// Change DI amount if DI percentage changes.
	onDIPercentageChange(_, value) {
		const diAmount = cleanNumber( this.props.proceedsValue ) * cleanNumber( value ) / 100
		if ( isNaN( diAmount ) ) {
			this.props.changeDiAmount( null )
		}
		this.props.changeDiAmount( formatNumber( diAmount ) )
	}

	// Change DI percentage if DI amount changes.
	onDIAmountChange(_, value) {
		const diPercentage = cleanNumber( value ) / cleanNumber( this.props.proceedsValue ) * 100
		if ( isNaN( diPercentage ) ) {
			this.props.changeDiPercent( null )
		}
		this.props.changeDiPercent( formatNumber( diPercentage ) )
	}

	// Change the DI amount, if the proceeds amount is changed.
	onProceedsAmountChange(_, value) {
		const diAmount = cleanNumber( value ) * cleanNumber( this.props.diPercentageValue ) / 100
		if ( isNaN( diAmount ) ) {
			this.props.changeDiAmount( null )
		}
		this.props.changeDiAmount( formatNumber( diAmount ) )
	}

	onBlurNoMultiSpaces( e, field ) {
		const value = removeMultipleSpaces( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}

	onBlurNoSpaces( e, field ) {
		const value = removeSpaces( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}

	onBlurCurrency( e, field ) {
		this.setState ( { focusedCurrency: false } )
		const value = formatNumber( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}

	onFocusCurrency( e ) {
		this.setState ( { focusedCurrency: true } )
	}

	parseCurrency( value ) {
		if ( this.state.focusedCurrency ) {
			return value
		}
		return cleanNumber( value )
	}

	formatCurrency( value ) {
		if ( this.state.focusedCurrency ) {
			return value
		}
		return formatNumber( value )
	}

	render() {
		let tab = this.getURLParam('tab')
		if ( tab && ! this.movedTabs ) {
			setTimeout( function() {
				if ( ! this.movedTabs ) {
					let tabFound = jQuery( `.tabbed-form .form-tab:eq(${tab})` );
					if ( tabFound.length ) {
						tabFound.click();
						this.movedTabs = true;
					}
				}
			}.bind( this ), 10 );
		}

		return (
			<Edit title={<AccountTitle />} {...this.props} actions={<EditActions/>}>
				<TabbedForm value="1">
		            <FormTab label="Details">
						<ReferenceInput label="Dealership" source="fields.dealership" reference="dealerships" allowEmpty validate={ value => isNotBlank( value ) ? null : 'This is required' } >
							<SelectInput/>
						</ReferenceInput>
						<TextInput label="First Name" source="fields.first_name" style={ inlineStyle } validate={ value => ! value && ! this.props.companyName ? 'A name or company is required' : null }
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.first_name' ) }
						/>
						<TextInput label="Middle Name" source="fields.middle_name" style={ inlineStyle }
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.middle_name' ) }
						/>
						<TextInput label="Last Name" source="fields.last_name" style={ inlineStyle } validate={ value => ! value && this.props.firstName ? 'This is required' : null }
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.last_name' ) }
						/>
						<TextInput label="Company Name" source="fields.company_name" options={{ fullWidth: true }} style={{ width: 544 }} validate={ value => ! value && ! this.props.firstName ? 'A name or company is required' : null }
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.company_name' ) }
						/>
						<TextInput label="Sales Consultant" source="fields.sales_consultant" options={{ fullWidth: true }} style={{ width: 544 }}
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.sales_consultant' ) }
						/>
						<TextInput label="Model" source="fields.model" style={ inlineStyle } 
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.model' ) }
						/>
						<TextInput label="Engine Number" source="fields.engine_number" style={ inlineStyle } 
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.engine_number' ) }
						/>
						<TextInput label="Chasis / Frame Number" source="fields.chasis_number" style={ inlineStyle } 
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.chasis_number' ) }
						/>
					</FormTab>
					<FormTab label="Payment">
						<ReferenceInput label="Bank" source="fields.bank" reference="banks" allowEmpty style={{ display: 'inline-block' }} validate={ value => isNotBlank( value ) ? null : 'This is required' }>
							<SelectInput/>
						</ReferenceInput>
						<ReferenceInput label="Payment Mode" source="fields.payment_mode" reference="bank_payment_modes" allowEmpty style={ inlineStyle } >
							<SelectInput/>
						</ReferenceInput>
						<br style={{ height: 0 }}/>
						<DateInput label="Insurance Policy Date" source="fields.insurance_policy_date" options={{ formatDate }} parse={dateString}/>
						<TextInput label="Invoice Number" source="fields.invoice_number" style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' } 
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.invoice_number' ) }
						/>
						<DateInput label="Invoice Date" source="fields.invoice_date" options={{ formatDate }} parse={dateString} style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' } />
						<TextInput label="Invoice Amount (₱)" source="fields.invoice_amount" style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' } 
							onBlur={ e => this.onBlurCurrency( e, 'fields.invoice_amount' ) } 
							onFocus={ this.onFocusCurrency.bind( this ) }
							parse={ this.parseCurrency.bind( this ) }
							format={ this.formatCurrency.bind( this ) }
						/>
						<TextInput label="Proceeds Amount (₱)" source="fields.proceeds" onChange={ this.onProceedsAmountChange.bind( this ) } validate={ value => isNotBlank( value ) ? null : 'This is required' } 
							onBlur={ e => this.onBlurCurrency( e, 'fields.proceeds' ) }
							onFocus={ this.onFocusCurrency.bind( this ) }
							parse={ this.parseCurrency.bind( this ) }
							format={ this.formatCurrency.bind( this ) } 
						/>
						<NumberInput label="Financing Rate (%)" source="fields.financing_rate" onBlur={ e => e.target.value = parseFloat( e.target.value ).toFixed( 2 ) } />
						<NumberInput label="Term" source="fields.term" />
						<TextInput label="DI Amount (₱)" source="fields.di_amount" onChange={this.onDIAmountChange.bind(this)} style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' }
							onBlur={ e => this.onBlurCurrency( e, 'fields.di_amount' ) }
							onFocus={ this.onFocusCurrency.bind( this ) }
							parse={ this.parseCurrency.bind( this ) }
							format={ this.formatCurrency.bind( this ) } 
						/>
						<NumberInput label="DI Percentage (%)" source="fields.di" onChange={this.onDIPercentageChange.bind(this)} style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' }/>
						<TextInput label="Chattel Mortgage Fee (₱)" source="fields.chattel_mortgage_fee" validate={ value => isNotBlank( value ) ? null : 'This is required' }
							onBlur={ e => this.onBlurCurrency( e, 'fields.chattel_mortgage_fee' ) }
							onFocus={ this.onFocusCurrency.bind( this ) }
							parse={ this.parseCurrency.bind( this ) }
							format={ this.formatCurrency.bind( this ) } 
						/>
						<TextInput label="Bank Contact Person" source="fields.bank_contact_person" style={ inlineStyle } 
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.bank_contact_person' ) }
						/>
						<TextInput label="Bank Contact Number" source="fields.bank_contact_number" style={ inlineStyle } 
							onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.bank_contact_number' ) }
						/>
					</FormTab>
					<FormTab label="Pending Documents">
						<PendingDocsEditTab />
					</FormTab>
					<FormTab label="Doc Defs">
						<DocDefEditTab />
					</FormTab>
				</TabbedForm>
		    </Edit>
		)
	}
}

export const DCAccountEdit = connect( state => ( {
	// Gets the value of some fields.
	proceedsValue: formValueSelector('record-form')(state, 'fields.proceeds'),
	diPercentageValue: formValueSelector('record-form')(state, 'fields.di'),
	firstName: formValueSelector('record-form')(state, 'fields.first_name'),
	lastName: formValueSelector('record-form')(state, 'fields.last_name'),
	companyName: formValueSelector('record-form')(state, 'fields.company_name'),
	invoiceAmount: formValueSelector('record-form')(state, 'fields.invoice_amount'),
	diAmount: formValueSelector('record-form')(state, 'fields.di_amount'),
	chattelMortgageFeeAmount: formValueSelector('record-form')(state, 'fields.chattel_mortgage_fee'),
} ) )(
	connect( null, {
		// Change the value of some input fields.
		changeDiPercent: val => change( 'record-form' , "fields.di" , val ),
		changeDiAmount: val => change( 'record-form' , "fields.di_amount" , val ),
		changeField: ( val, field ) => change( 'record-form' , field, val ),
	} ) ( _DCAccountEdit )
)


// Cannot use this now, wait for this to be fixed: https://github.com/marmelab/aor-dependent-input/issues/18
// <DependentInput dependsOn="name" value="other">
// 	<TextInput label="Other" source="document_other_name"/>
// </DependentInput>

const postRowStyle = (record, index) => {

	const { is_late_release } = record.fields
	if ( is_late_release ) {
		return { backgroundColor: '#ffebee' }
	}
	return { backgroundColor: '' }
}

export const DCAccountList = (props) => (
    <List {...props}
		filters={<AccountFilters />}
		actions={<AccountListActions refreshInterval="900000" />}
		perPage={25}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.fields.cs_num}
            //         secondaryText={record => `${record.fields.branch} views`}
            //         tertiaryText={record => record.fields.dealer}
            //     />
            // }
            large={
				<Datagrid
					rowStyle={postRowStyle}
					>
		            <AccountLinkField source="fields.cs_num" label="CS #" sortable={false} />
					<FunctionField label="Customer" render={customerName} />
					<ReferenceField label="Account type" source="fields.payment_mode" reference="bank_payment_modes" linkType={false} sortable={false}>
						<TextField source="name"/>
					</ReferenceField>
					<FunctionField label="Dealership" render={ record => stringHumanize(record.fields.dealership) } />
					<ReferenceField label="Bank" source="fields.bank" reference="banks" allowEmpty validation={{ required: true }} linkType={false} sortable={false}>
						<TextField source="name"/>
					</ReferenceField>
					<FunctionField label="Status" render={simpleStatus} />
					<DocStatus label="Docs Status" />
					<FunctionField label="Released" render={ record => record.fields.released_date ? formatDate( record.fields.released_date ) : '' } />
					<DCButtons label="Action" record={ props.record } />
					<EditButton label="Edit" />
		        </Datagrid>
            }
        />
    </List>
)

const defaultCreateAccount = {
	status: 'publish',
	fields: {
		status: 'new',
		is_released: false,
		is_transmitted: false,
		invoice_date: formatDate(),
		di: '15.00',
		payment_mode: 'bank_financing',
	},
};

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidate = (values/*, dispatch */) => {
  return sleep(1000) // simulate server latency
    .then(() => {
      if ([ 'john', 'paul', 'george', 'ringo' ].includes(values.username)) {
        throw { username: 'That username is taken' }
      }
    })
}


const validateCSNum = ( value, allValues ) => {
	if ( value ) {
		const requestHeaders = new Headers({
            Accept: 'application/json',
			'Content-Type': 'application/json',
        } );

		const content = {
			cs_num: value.fields.cs_num,
		}
		return fetch( `${restURL}/cs_num_check`, { method: 'PUT', headers: requestHeaders, body: JSON.stringify( content ) } )
            .then( response =>
	            response.text().then(text => ({
	                status: response.status,
	                statusText: response.statusText,
	                headers: response.headers,
	                body: text,
	            }))
			)
	        .then(({ status, statusText, headers, body }) => {
	            let json;
	            try {
	                json = JSON.parse(body);
	            } catch (e) {
	                // not json, no big deal
	            }
	            if (status < 200 || status >= 300) {
	                return Promise.reject(
	                    new HttpError(
	                        statusText,
	                        status,
							json
	                    )
	                );
	            }
				if ( json.error ) {
					throw {
						fields: {
							cs_num: json.error,
						},
					}
				}
	        } );
	}
}

// export const DCAccountCreate = (props) => (
class _DCAccountCreate extends Component {
	state = {
		focusedCurrency: false,
	}

	// Change DI amount if DI percentage changes.
	onDIPercentageChange(_, value) {
		const diAmount = cleanNumber( this.props.proceedsValue ) * cleanNumber( value ) / 100
		if ( isNaN( diAmount ) ) {
			this.props.changeDiAmount( null )
		}
		this.props.changeDiAmount( formatNumber( diAmount ) )
	}

	// Change DI percentage if DI amount changes.
	onDIAmountChange(_, value) {
		const diPercentage = cleanNumber( value ) / cleanNumber( this.props.proceedsValue ) * 100
		if ( isNaN( diPercentage ) ) {
			this.props.changeDiPercent( null )
		}
		this.props.changeDiPercent( formatNumber( diPercentage ) )
	}

	// Change the DI amount, if the proceeds amount is changed.
	onProceedsAmountChange(_, value) {
		const diAmount = cleanNumber( value ) * cleanNumber( this.props.diPercentageValue ) / 100
		if ( isNaN( diAmount ) ) {
			this.props.changeDiAmount( null )
		}
		this.props.changeDiAmount( formatNumber( diAmount ) )
	}

	onBlurNoMultiSpaces( e, field ) {
		const value = removeMultipleSpaces( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}

	onBlurNoSpaces( e, field ) {
		const value = removeSpaces( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}
	onBlurCSNum( e, field ) {
		const value = cleanCSNum( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}

	onBlurCurrency( e, field ) {
		this.setState ( { focusedCurrency: false } )
		const value = formatNumber( e.target.value )
		setTimeout( () => this.props.changeField( value, field ), 1 )
	}

	onFocusCurrency( e ) {
		this.setState ( { focusedCurrency: true } )
	}

	parseCurrency( value ) {
		if ( this.state.focusedCurrency ) {
			return value
		}
		return cleanNumber( value )
	}

	formatCurrency( value ) {
		if ( this.state.focusedCurrency ) {
			return value
		}
		return formatNumber( value )
	}

	normalizeNumber(value) {

		return value
	}

	render() {
		return (
    <Create {...this.props}>
        <SimpleForm defaultValue={defaultCreateAccount} asyncValidate={ validateCSNum } asyncBlurFields={[ 'fields.cs_num' ]}>
			<h2>General</h2>
            <TextInput label="CS #" source="fields.cs_num" validate={ value => isNotBlank( value ) ? null : 'This is required' }
				onBlur={ e => this.onBlurCSNum( e, 'fields.cs_num' ) }
			/>
			<ReferenceInput label="Dealership" source="fields.dealership" reference="dealerships" allowEmpty validate={ value => isNotBlank( value ) ? null : 'This is required' } >
				<SelectInput/>
			</ReferenceInput>
			<br style={{ height: 0 }}/>
			<TextInput label="First Name" source="fields.first_name" style={ inlineStyle } validate={ value => ! value && ! this.props.companyName ? 'A name or company is required' : null }
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.first_name' ) }
			/>
			<TextInput label="Middle Name" source="fields.middle_name" style={ inlineStyle }
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.middle_name' ) }
			/>
			<TextInput label="Last Name" source="fields.last_name" style={ inlineStyle } validate={ value => ! value && this.props.firstName ? 'This is required' : null } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.last_name' ) }
			/>
			<TextInput label="Company Name" source="fields.company_name" validate={ value => ! value && ! this.props.firstName ? 'A name or company is required' : null } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.company_name' ) }
			/>
			<TextInput label="Sales Consultant" source="fields.sales_consultant" 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.sales_consultant' ) }
			/>
			<br/>
			<TextInput label="Model" source="fields.model" style={ inlineStyle } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.model' ) }
			/>
			<TextInput label="Engine Number" source="fields.engine_number" style={ inlineStyle } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.engine_number' ) }
			/>
			<TextInput label="Chasis / Frame Number" source="fields.chasis_number" style={ inlineStyle } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.chasis_number' ) }
			/>
			<h2 style={{ marginTop: 64 }}>Payment</h2>
			<ReferenceInput label="Bank" source="fields.bank" reference="banks" allowEmpty style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' }>
				<SelectInput/>
			</ReferenceInput>
			<ReferenceInput label="Payment Mode" source="fields.payment_mode" reference="bank_payment_modes" allowEmpty style={ inlineStyle } >
				<SelectInput/>
			</ReferenceInput>
			<br style={{ height: 0 }}/>
			<DateInput label="Insurance Policy Date" source="fields.insurance_policy_date" options={{ formatDate }} parse={dateString}/>
			<TextInput label="Invoice Number" source="fields.invoice_number" style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' }
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.invoice_number' ) }
			/>
			<DateInput label="Invoice Date" source="fields.invoice_date" options={{ formatDate }} parse={dateString} style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' }/>
			<TextInput label="Invoice Amount (₱)" source="fields.invoice_amount" style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' } 
				onBlur={ e => this.onBlurCurrency( e, 'fields.invoice_amount' ) }
				onFocus={ this.onFocusCurrency.bind( this ) }
				parse={ this.parseCurrency.bind( this ) }
				format={ this.formatCurrency.bind( this ) } 
			/>
			<NumberInput label="Financing Rate (%)" source="fields.financing_rate" onBlur={ e => e.target.value = parseFloat( e.target.value ).toFixed( 2 ) } />
			<NumberInput label="Term" source="fields.term" />
			<TextInput label="Proceeds Amount (₱)" source="fields.proceeds" onChange={this.onProceedsAmountChange.bind(this)} validate={ value => isNotBlank( value ) ? null : 'This is required' }  
				onBlur={ e => this.onBlurCurrency( e, 'fields.proceeds' ) }
				onFocus={ this.onFocusCurrency.bind( this ) }
				parse={ this.parseCurrency.bind( this ) }
				format={ this.formatCurrency.bind( this ) } 
			/>
			<TextInput label="DI Amount (₱)" source="fields.di_amount" onChange={this.onDIAmountChange.bind(this)} style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' } 
				onBlur={ e => this.onBlurCurrency( e, 'fields.di_amount' ) }
				onFocus={ this.onFocusCurrency.bind( this ) }
				parse={ this.parseCurrency.bind( this ) }
				format={ this.formatCurrency.bind( this ) } 
			/>
			<NumberInput label="DI Percentage (%)" source="fields.di" onChange={this.onDIPercentageChange.bind(this)} style={ inlineStyle } validate={ value => isNotBlank( value ) ? null : 'This is required' }/>
			<TextInput label="Chattel Mortgage Fee (₱)" source="fields.chattel_mortgage_fee" validate={ value => isNotBlank( value ) ? null : 'This is required' } 
				onBlur={ e => this.onBlurCurrency( e, 'fields.chattel_mortgage_fee' ) }
				onFocus={ this.onFocusCurrency.bind( this ) }
				parse={ this.parseCurrency.bind( this ) }
				format={ this.formatCurrency.bind( this ) } 
			/>
			<TextInput label="Bank Contact Person" source="fields.bank_contact_person" style={ inlineStyle } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.bank_contact_person' ) }
			/>
			<TextInput label="Bank Contact Number" source="fields.bank_contact_number" style={ inlineStyle } 
				onBlur={ e => this.onBlurNoMultiSpaces( e, 'fields.bank_contact_number' ) }
			/>
        </SimpleForm>
    </Create>
	)
}
}

export const DCAccountCreate = connect( state => ( {
	// Gets the value of some fields.
	proceedsValue: formValueSelector('record-form')(state, 'fields.proceeds'),
	diPercentageValue: formValueSelector('record-form')(state, 'fields.di'),
	firstName: formValueSelector('record-form')(state, 'fields.first_name'),
	lastName: formValueSelector('record-form')(state, 'fields.last_name'),
	companyName: formValueSelector('record-form')(state, 'fields.company_name'),
	companyName: formValueSelector('record-form')(state, 'fields.company_name'),
	invoiceAmount: formValueSelector('record-form')(state, 'fields.invoice_amount'),
	diAmount: formValueSelector('record-form')(state, 'fields.di_amount'),
	chattelMortgageFeeAmount: formValueSelector('record-form')(state, 'fields.chattel_mortgage_fee'),
} ) )(
	connect( null, {
		// Change the value of some input fields.
		changeDiPercent: val => change( 'record-form' , "fields.di" , val ),
		changeDiAmount: val => change( 'record-form' , "fields.di_amount" , val ),
		changeField: ( val, field ) => change( 'record-form' , field, val ),
	} ) ( _DCAccountCreate )
)



// WEBPACK FOOTER //
// ./src/DCAccount/index.js